<template>
  <!-- 配送及时率 -->
  <div class="month-analye">
    <table class="mytable">
      <thead>
        <tr>
          <th style="width:10%;">天数</th>
          <th v-for="(mon,index) in 31" :key="index">{{index+1}}日</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background:#203bd5;text-align:center">减排量(吨标煤)</td>
          <td v-for="(item,index) in formData" :key="index">
            <el-input type="number" v-model="item.lossPower" placeholder="请输入">
            </el-input>
          </td>
        </tr>
      </tbody>
    </table>

    <div style="margin-top: 1rem;">
      <el-button :loading="analyeLoading" @click="saveAnalye" size="small" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/power/power'
export default {
  components: {},
  data() {
    return {
      analyeLoading:false,//加载状态

      formData: [
        {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},
        {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},
        {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''}
      ],
    }
  },
  mounted() {
    this.getAnalye();//获取需量分析
  },
  methods: {
    //保存需量分析
    saveAnalye() {
      let obj = {
        jsonData:JSON.stringify(this.formData)
      }
      this.analyeLoading = true;
      api.saveNeedData(obj).then((res) => {
        if (res.code === 10000) {
          this.$message.success('保存成功')
          this.getAnalye();
          this.analyeLoading = false;
        } else {
          this.$message.error(res.message)
          this.analyeLoading = false;
          return;
        }
      })
    },
    //获取需量分析
    getAnalye(){
      api.getNeedData().then(res=>{
        if(res.data){
          this.formData = JSON.parse(res.data.jsonData)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.month-analye { padding-top: 10px;}
</style>